import React from 'react';
import { useState, useEffect } from 'react';
import Form from "react-bootstrap/Form";
import { Button, Modal } from 'react-bootstrap';
import { putWithAuth, getWithAuth } from '../../api/api';
import { API_URLS } from '../../api/apiConfig';
import { useNavigate } from 'react-router-dom';


const ModalUpdateRoom = ({ onClose, room }) => {
    const [showAlert, setIshowAlert] = useState(false);
    const [alertMessage, setShowAlertMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [categoriesList, setCategories] = useState([]);

    const [updateRoom, setRoom] = useState({ ...room });

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setRoom((prevRoom) => ({
            ...prevRoom,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const data = await getWithAuth(API_URLS.GET_CATEGORIES);
                setCategories(data.data);
            } catch (error) {
                setIshowAlert(true);
                setShowAlertMessage("Error al cargar las categorías");
            }
        };
        fetchCategories();
    }, []);

    const editRoom = async () => {
        try {
            setIsLoading(true);
            const response = await putWithAuth(API_URLS.EDIT_ROOM(room.id), updateRoom);
            if (response.message === 'success') {
                setIsLoading(false);
                window.location.reload();
            } else {
                setIsLoading(false);
                setIshowAlert(true);
                setShowAlertMessage(response.detail || "Ha ocurrido un error");
            }
        } catch (error) {
            console.error('Error editing room:', error);
            setIsLoading(false);
            setIshowAlert(true);
            setShowAlertMessage("Error interno al editar la habitación");
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!updateRoom.category_id) {
            setIshowAlert(true);
            setShowAlertMessage("Por favor, selecciona una categoría");
            return;
        }
        editRoom();
    };

    return (
        <Modal show={true} onHide={onClose} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>Editar Habitación</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="form">
                    <div className="modal-body py-10 px-lg-17">
                        <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
                            <i className="ki-outline ki-information fs-2tx text-warning me-4"></i>
                            <div className="d-flex flex-stack flex-grow-1">
                                <div className="fw-semibold">
                                    <h4 className="text-gray-900 fw-bold">¡Atención!</h4>
                                    <div className="fs-6 text-gray-700">
                                        Editar una habitación puede afectar el resultado final de limpiezas.
                                    </div>
                                </div>
                            </div>
                        </div>

                        {showAlert && (
                            <div className="alert alert-danger d-flex align-items-center p-5">
                                <i className="fa-solid fa-triangle-exclamation fs-1 text-danger me-4"></i>
                                <div className="d-flex flex-column">
                                    <span className="mb-1 text-danger">{alertMessage}</span>
                                </div>
                            </div>
                        )}

                        <div className="row g-9 mb-8">
                            <div className="col-md-6">
                                <label className="required fs-6 fw-semibold mb-2">Número de la habitación</label>
                                <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    placeholder="12"
                                    name="number"
                                    onChange={handleInputChange}
                                    value={updateRoom.number || ""}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="required fs-6 fw-semibold mb-2">Nombre de la habitación</label>
                                <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    placeholder="Doble con vistas al mar y baño"
                                    name="name"
                                    onChange={handleInputChange}
                                    value={updateRoom.name || ""}
                                />
                            </div>
                        </div>

                        <div className="row g-9 mb-8">
                            <div className="col-md-4">
                                <label className="required fs-6 fw-semibold mb-2">Código de la habitación en RR</label>
                                <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    placeholder="3243"
                                    name="rr_code"
                                    onChange={handleInputChange}
                                    value={updateRoom.rr_code || ""}
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="required fs-6 fw-semibold mb-2">Mínima capacidad</label>
                                <input
                                    type="number"
                                    className="form-control form-control-solid"
                                    placeholder="0"
                                    name="min_capacity"
                                    onChange={handleInputChange}
                                    value={updateRoom.min_capacity || ""}
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="required fs-6 fw-semibold mb-2">Máxima capacidad</label>
                                <input
                                    type="number"
                                    className="form-control form-control-solid"
                                    placeholder="2"
                                    name="max_capacity"
                                    onChange={handleInputChange}
                                    value={updateRoom.max_capacity || ""}
                                />
                            </div>
                        </div>

                        <div className="row g-9 mb-8">
                            <div className="col-md-6">
                                <label className="required fs-6 fw-semibold mb-2">Categoría</label>
                                <select
                                    name="category_id"
                                    className="form-select form-select-solid"
                                    onChange={handleInputChange}
                                    value={updateRoom.category_id || ""}
                                    required
                                >
                                    {categoriesList.map((cat) => (
                                        <option key={cat.id} value={cat.id}>
                                            {cat.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer flex-center">
                        <button type="reset" className="btn btn-light me-3" onClick={onClose}>
                            Cancelar
                        </button>
                        <button type="submit" onClick={handleSave} className="btn btn-primary" data-kt-indicator={`${isLoading ? 'on' : 'off'}`}>
                            <span className="indicator-label">Editar habitación</span>
                            <span className="indicator-progress">
                                Guardando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default ModalUpdateRoom;
